<template>
  <div style="width: 100%;height: 100%;" class="px-16px pt-16px pb-16px">
    <div class="search flex items-center gap-4px mb-[16px]">
      <el-input v-model="searchValue" placeholder="请输入搜索内容" clearable :prefix-icon="Search" style="margin-right: 16px;"
        @clear="searchShow = false"></el-input>
      <el-button type="primary" @click="handleSearch" style="background-color: #2a66ff;">搜索</el-button>
    </div>
    <div v-show="elementListShow == false && collectListShow == false && searchShow == false" class="home">
      <div class="menu-list grid grid-cols-4 gap-12px" style="gap: 12px;" v-if="!loadingMenu">
        <div v-for="item in menuList" :key="item.id" @click="handleCategoryClick(item)" class="menu-item" :style="{
          'backgroundImage': `url(${item.preview_url})`
        }">
        </div>
      </div>
      <div class="menu-list grid grid-cols-4 gap-12px" style="gap: 12px;" v-else>
        <div v-for="n in 8" :key="n" class="menu-item">
          <el-skeleton animated>
            <template #template>
              <el-skeleton-item variant="rect" class="skeleton-card" />
            </template>
          </el-skeleton>
        </div>
      </div>
      <div class="collection mb-[32px]">
        <div class="title flex items-center justify-between mt-[32px] mb-[16px]" v-if="collectNum > 0">
          <div class="text-ellipsis whitespace-nowrap overflow-hidden font-bold">合集</div>
          <div class="more cursor-pointer" @click="collectListShow = true"> 更多</div>
        </div>
        <collectList :showNum="4" @selectMore="handleMoreClick($event, 'collect')" @num="handleNum($event, 'collect')">
        </collectList>
      </div>
      <recommendSection @more="handleMoreClick($event, 'materials')"  @num="handleNum($event, 'recommend')"/>
       <div v-if="menuList.length == 0&& collectNum == 0&&recommendNum==0" >
        <el-empty description="暂无数据" />
      </div>
    </div>
    <div class="element-list h-[calc(100%-40px)]" v-if="elementListShow">
      <elementlist :categoriesShow="categoriesShow" @back="elementListShow = false" :category="categoryopt"
        :type="elementType">
      </elementlist>
    </div>
    <div class="collectList  h-[calc(100%-40px)]" v-if="collectListShow">
      <collect @back="collectListShow = false"></collect>
    </div>
    <div class="search  h-[calc(100%-40px)]" v-if="searchShow">
      <search @back="searchShow = false" ref="searchRef"></search>
    </div>
   
  </div>
</template>
<script lang="ts" setup>
import { onMounted, ref, nextTick } from 'vue'
import { ElInput, ElButton, ElCascader, ElSkeleton, ElSkeletonItem, ElEmpty } from 'element-plus'
import { ArrowDown, Search } from '@element-plus/icons-vue'
import { getVectorCategory, getCategories, recommendations, } from '@/api/affairs'
// @ts-ignore
// @ts-ignore
import recommendSection from './recommendSection.vue'
// @ts-ignore
import elementlist from './elementlist.vue'
// @ts-ignore
import collectList from './collectList.vue'
// @ts-ignore
import collect from './collect.vue'
// @ts-ignore
import search from './search.vue'
const menuList = ref([])
const loadingMenu = ref(true)
const recommendList = ref([])
const searchRef = ref<search>()
const searchValue = ref('')
const handleSearch = () => {
  if (searchValue.value.trim() === '') {
    searchShow.value = false
    return
  }
  searchShow.value = true
  elementListShow.value = false
  collectListShow.value = false

  nextTick(() => {
    searchRef.value?.searchList(searchValue.value)
  })
}
const elementListShow = ref(false)
const collectListShow = ref(false)
const searchShow = ref(false)
const categoriesShow = ref(true)

const List = ref([])
const collectNum = ref(0)
const recommendNum=ref(0)
const elementType = ref('')
const handleNum = (num, type) => {
  if (type == 'collect') {
    collectNum.value = num
  }
  if (type == 'recommend') {
    recommendNum.value = num
  }
}
onMounted(() => {
  getVectorCategory({ page: 1, size: 10 }).then(res => {
    menuList.value = res.data.data.items
  }).finally(() => {
    loadingMenu.value = false
  })
  getList()
})
const categoryopt = ref({})
const handleCategoryClick = (item) => {
  categoryopt.value = item
  categoriesShow.value = true
  elementListShow.value = true
  elementType.value = 'svg'
  console.log(item)
}
const getList = () => {

}
const handleMoreClick = (item, type) => {
  categoriesShow.value = false
  elementListShow.value = true
  elementType.value = type
  console.log(item)
  categoryopt.value = item
}
const getimage = (val) => {
  return val.slice(0, 3)
}
</script>
<style lang="scss">
.home {
  height: calc(100% - 40px);
  overflow: auto;
}

::-webkit-scrollbar {
  width: 0;
  height: 0;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

.menu-item {
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
  background-color: #fff;
  background-size: 100% 100%;
  height: 38px !important;

}

.skeleton-card {
  width: 100%;
  height: 38px;
  border-radius: 6px;
}
</style>
